import React from "react";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { Link } from "react-router";
import { useQuery } from "@tanstack/react-query";
import { fetchCollection, queryKeys } from "@/src/services/reactQuery/reactQueryService";
import { AbstractCase } from "@/src/types/Entities/AbstractCase";
import { caseHasUnreadMessage } from "@/src/services/messagingService";
import ProductBoxGrid from "@/src/components/ProductBoxGrid/ProductBoxGrid";
import ContentBox from "@/src/components/Box/ContentBox/ContentBox";

type NewMessageCaseBoxProps = {
  product: AbstractCase;
};
export default function NewMessageCaseBox({ product }: NewMessageCaseBoxProps) {
  const { data: conversations, isLoading } = useQuery({
    queryKey: queryKeys.collection("/conversations"),

    queryFn: () => fetchCollection("/conversations"),
  });

  if (isLoading || !conversations) {
    return null;
  }

  if (!caseHasUnreadMessage(product.id, conversations)) {
    return null;
  }

  return (
    <ContentBox headline={"Neue Nachricht"}>
      <ProductBoxGrid
        items={[
          <Typography>Es liegt eine neue Nachricht für Sie vor. Sie finden diese in Ihrem Nachrichtenbereich.</Typography>,
          <Button variant={"contained"} fullWidth component={Link} to={"/servicewelt/nachrichten/fall/" + product.id}>
            Nachricht lesen
          </Button>,
        ]}
      />
    </ContentBox>
  );
}
